import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import LoadingStateWrapper from '@swf/sports/components/LoadingStateWrapper/LoadingStateWrapper';

import styles from './LoadingState.scss';

const WidgetRow: React.FC = () => (
  <div className={styles.widgetRow}>
    <Skeleton variant="rectangular" height="21px" width="350px" animation="pulse" />
    <Skeleton variant="rectangular" height="40px" width="70px" animation="pulse" />
  </div>
);

const WidgetHeaderRow: React.FC = () => (
  <div className={styles.widgetHeaderRow}>
    <Skeleton variant="rectangular" height="21px" width="21px" animation="pulse" />
    <Skeleton variant="rectangular" height="21px" width="200px" animation="pulse" />
  </div>
);

export const HomePageLoadingState: React.FC = () => (
  <LoadingStateWrapper>
    <div className={styles.wrapper}>
      <Skeleton variant="rectangular" height="48px" width="100%" animation={false} />
      <div className={styles.cardWrapper}>
        <Skeleton className={styles.card} variant="rectangular" height="365px" />
      </div>
    </div>
    <div className={styles.wrapper}>
      <Skeleton variant="rectangular" height="48px" width="100%" animation={false} />
      <WidgetHeaderRow />
      <WidgetRow />
      <WidgetRow />
      <WidgetRow />
      <WidgetHeaderRow />
      <WidgetRow />
      <WidgetRow />
    </div>
  </LoadingStateWrapper>
);
